<script setup>
import {Head, Link, useForm, usePage} from "@inertiajs/inertia-vue3";
import Layout from "../Layouts/Authenticated.vue";
import {computed, ref} from "vue";
import {useToast} from "primevue/usetoast";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Message from "primevue/message";

const page = usePage()
const toast = useToast();

const errors = ref({})

const form = useForm({
    email: page.props.value.auth.user.email,
    password: null,
    password_confirmation: null,
    forename: page.props.value.auth.user.forename,
    surname: page.props.value.auth.user.surname,
    phone: page.props.value.auth.user.phone,
    mobile: page.props.value.auth.user.mobile,
});

const submit = () => {
    errors.value = {}

    form.post(`/profile/`, {
        preserveState: true,

        onSuccess: () => {
            toast.add({
                severity: "success",
                summary: "Profil aktualisiert",
                life: 5000,
            });
        },

        onError: (errorsResponse) => {
            errors.value = errorsResponse


        },

        onFinish: () => {
            form.password = null
            form.password_confirmation = null
        }
    })
}

const hasErrors = computed(() => {
    return Object.keys(errors.value).length > 0
})

</script>

<template>
    <Layout>
        <Head title="Profil" />

        <div class="max-w-4xl mx-auto py-7 px-14 my-10 bg-white text-sm">
            <h1 class="text-black text-lg font-bold mb-9">
                Profil
            </h1>

            <Message v-if="hasErrors" severity="error">
                <div v-for="(data, key) in errors">{{ data[0] }}</div>
            </Message>

            <form @submit.prevent="submit">
                <div class="grid grid-cols-2 gap-4 mb-5">
                    <div>
                        <label class="font-bold">Email</label>

                        <InputText
                            v-model="form.email"
                            type="email"
                            class="w-full"
                        />
                    </div>

                    <div>
                    </div>

                    <div>
                        <label class="font-bold">Passwort</label>

                        <InputText
                            v-model="form.password"
                            type="password"
                            class="w-full"
                        />
                    </div>

                    <div>
                        <label class="font-bold">Passwortbestätigung</label>

                        <InputText
                            v-model="form.password_confirmation"
                            type="password"
                            class="w-full"
                        />
                    </div>

                    <div>
                        <label class="font-bold">Forename</label>

                        <InputText
                            v-model="form.forename"
                            type="text"
                            class="w-full"
                        />
                    </div>

                    <div>
                        <label class="font-bold">Surname</label>

                        <InputText
                            v-model="form.surname"
                            type="text"
                            class="w-full"
                        />
                    </div>

                    <div>
                        <label class="font-bold">Telefon</label>

                        <InputText
                            v-model="form.phone"
                            type="text"
                            class="w-full"
                        />
                    </div>

                    <div>
                        <label class="font-bold">Natel</label>

                        <InputText
                            v-model="form.mobile"
                            type="text"
                            class="w-full"
                        />
                    </div>
                </div>

                <div class="flex justify-between">
                    <div>
                        <Button
                            asChild
                            v-slot="slotProps"
                            severity="secondary"
                            type="button"
                            class="!border-none">
                            <Link href="/" :class="slotProps.class">Zurück</Link>
                        </Button>
                    </div>

                    <div>
                        <Button
                            label="Speichern"
                            class="min-w-[100px] !bg-black !text-[#FFF053] !border-none"
                            type="submit"
                            :disabled="form.processing"
                            :loading="form.processing"
                        />
                    </div>
                </div>
            </form>
        </div>
    </Layout>
</template>
